import { render, staticRenderFns } from "./FileElement.vue?vue&type=template&id=0f09f2a0&scoped=true"
import script from "./FileElement.vue?vue&type=script&lang=js"
export * from "./FileElement.vue?vue&type=script&lang=js"
import style0 from "./FileElement.vue?vue&type=style&index=0&id=0f09f2a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f09f2a0",
  null
  
)

export default component.exports